<template>
    <div class="col-lg-9 p-2 p-lg-4">
        <div class="d-flex mb-4">
            <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked @click="change_date_type(0)">
                <label class="btn btn-outline-primary" for="btnradio1">即時</label>
                <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" @click="change_date_type(1)">
                <label class="btn btn-outline-primary" for="btnradio2">歷史</label>
            </div>
            <button class="ms-auto btn btn-warning" @click="export_csv()">CSV</button>
        </div>
        <div id="plot_div" style="position: relative;"></div>
        <div class="row g-0" v-if="date_type == 1">
            <div class="col-12 col-md-10 col-lg-3 col-xl-3 col-xxl-2 mb-2 pe-lg-2">
                <select class="form-select" v-model="date_range">
                    <option :value="0" v-if="datatype_interval === 0">即時</option>
                    <option :value="1" v-if="datatype_interval === 1">日</option>
                    <option :value="2" v-if="datatype_interval === 1">月</option>
                    <option :value="3" v-if="datatype_interval === 1">年</option>
                    <option :value="4" v-if="datatype_interval === 1">歷年</option>
                     
                </select>
            </div>
            <div class="col-12 col-lg-9 col-xl-9 col-xxl-10 mb-2">
                <label>搜尋區間</label>
                <date-picker class="col-12 col-md-9 col-lg-9 col-xl-8 col-xxl-7" v-model="date1" type="date" 
                value-type="format" format="YYYY-MM-DD"
                range placeholder="請選擇搜尋區間" :clearable="false" @change="history_data_list()"
                :disabled-date="(date) => date >= new Date()"></date-picker>
            </div>
            
        </div>
    </div>
</template>

<script>

//import PlotClass from "../assets/js/plantinfo"
import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import "vue2-datepicker/locale/zh-tw"
import moment from "moment"
import Plotly from "plotly.js"

export default {
    name: "point-plot-zone", 
    props: ['ID', 'datatype', 'collection', 'type'],
    components: {
        DatePicker
    },
    data(){
        return{
            date1: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
            datatype_interval: 0,
            date_range: 0,
            date_type: 0,
            plot_type: "scatter",
            equip_type: "",
            arr1: [],
        }
    },
    methods:{
        history_data_list(){
            let datepicker1 = ""
            let datepicker2 = ""
            let date_range = 0
            if(this.date_type == 0){
                datepicker1 = moment().format('YYYY-MM-DD')
                datepicker2 = moment().format('YYYY-MM-DD')
                date_range = 0
                if(this.datatype_interval == 1){
                    date_range = 1
                }
            }else{
                datepicker1 = this.date1[0]
                datepicker2 = this.date1[1]
                date_range = this.date_range
            }
            const that = this
            this.axios.get(`/history_data_list`,{
                params: {
                    history_ID: this.$props.ID, datacollection: this.$props.collection,
                    datatype: this.$props.datatype, datepicker1: datepicker1,
                    datepicker2: datepicker2, date_range: date_range
                }
            })
            .then(function (data) {
                // 帶入params
                const MyPlot = document.getElementById('plot_div')
                let layout = {
                    width: document.getElementById('plot_div').clientWidth,
                    height: document.getElementById('plot_div').clientHeight,
                    margin: that.plot_margin(),
                    legend: {
                        x: 1,
                        xanchor: 'right',
                        y: 1
                    }
                }
                let arr1 = []
                if(Array.isArray(data.data.y_axis[0])){
                    var _len = data.data.y_axis.length
                    for(var i=0; i < _len; i++){
                        let trace_name = ""
                        if(that.datatype == "p" || that.datatype.split("_")[0] == "p"){
                            switch(i){
                                case 0:
                                    trace_name = "功率(W)"
                                    break
                                case 1:
                                    trace_name = "日照計(W/m²)"
                                    break
                            }
                        }
                        if(i == 0){
                            layout['yaxis'] = {'title': trace_name}
                            arr1.push({
                                x: data.data.x_axis,
                                y: data.data.y_axis[i],
                                type: that.plot_type,
                                name: trace_name
                            })
                        }else{
                            layout['yaxis'+(parseInt(i)+1)] = {'title': trace_name, overlaying: 'y',
                            side: 'right'}
                            arr1.push({
                                x: data.data.x_axis,
                                y: data.data.y_axis[i],
                                yaxis: 'y'+(parseInt(i)+1),
                                type: that.plot_type,
                                name: trace_name
                            })
                        }
                        
                    }
                }else{
                    let trace_name = ""
                    switch(that.datatype){
                        case 'v':
                            trace_name = "電壓(V)"
                            break
                        case 'i':
                            trace_name = "電流(A)"
                            break
                        case 'p':
                            trace_name = "功率(kW)"
                            break
                        case 'f':
                            trace_name = "頻率(Hz)"
                            break
                        case 'PR':
                            trace_name = "PR(%)"
                            break
                        case 'RA':
                            trace_name = "RA(%)"
                            break
                        case 'DMY':
                            trace_name = "DMY(小時)"
                            break
                        case 'kwh':
                            trace_name = "發電量(kWh)"
                            break
                        case 'value':
                            switch(that.equip_type){
                                case 'sun':
                                    trace_name = "日照強度(W/m²)"
                                    break
                                case 'temp':
                                    trace_name = "溫度(°C)"
                                    break
                                case 'wind':
                                    trace_name = "風速(m/s)"
                                    break
                                default:
                                    trace_name = ""
                                    break
                            }
                            break
                        default:
                            if(that.datatype.startsWith('p_cell_') || that.datatype.startsWith('p_bus_')){
                                trace_name = "功率(kW)"
                            }else if(that.datatype.startsWith('v_cell_') || that.datatype.startsWith('v_bus_')){
                                trace_name = "電壓(V)"
                            }else if(that.datatype.startsWith('i_cell_') || that.datatype.startsWith('i_bus_') ||
                            that.datatype.startsWith('sa')){
                                trace_name = "電流(A)"
                            }else if(that.datatype.startsWith('f_cell_') || that.datatype.startsWith('f_bus_')){
                                trace_name = "頻率(Hz)"
                            }else{
                                trace_name = ""
                            }                       
                            break
                    }
                    layout['yaxis'] = {'title': trace_name}
                    arr1.push({
                        x: data.data.x_axis,
                        y: data.data.y_axis,
                        type: that.plot_type,
                        name: trace_name
                    })
                }
                //console.log(arr1)
                that.arr1 = arr1

                Plotly.newPlot( MyPlot, arr1, layout,
                    {
                        displaylogo: false,
                        modeBarButtonsToRemove: [
                            "sendDataToCloud",
                            "hoverClosestCartesian",
                            "hoverCompareCartesian",
                            "toggleSpikelines",
                        ],
                    }
                )
            })
        },
        change_date_type(type){
            this.date_type = type
            this.history_data_list()
        },
        plot_resize(){
            let update = {
                width: "",
                heigth: "",
            }
            update = {
                width: document.getElementById('plot_div').clientWidth,
                height:  document.getElementById('plot_div').clientHeight,
                margin: this.plot_margin()
            }
            Plotly.relayout("plot_div", update)
        },
        plot_margin(){
            let margin =  {
                l: 80,
                r: 50,
                b: 40,
                t: 50,
                pad: 4,
            }
            if(document.getElementById('plot_div').clientWidth < 550){
                margin.l = 40
                if(this.datatype == "p" || this.datatype.split("_")[0] == "p"){
                    margin.r = 40
                }else{
                    margin.r = 0
                }
                margin.pad = 1
            }
            return margin
        },
        export_csv(){
            console.log(this.arr1)
            let header = "Time"
            if(!Array.isArray(this.arr1)){
                alert("無資料")
                return false
            }
            for(var i in this.arr1){
                if(this.arr1[i]["name"] !== undefined && this.arr1[i]["name"] !== null){
                    header += `,${this.arr1[i]["name"]}`
                }else{
                    header += `,Data${parseInt(i)+1}`
                }
            }
            header += "\n"
            let body = ""
            for(var _pos in this.arr1[0]["x"]){
                body += `${this.arr1[0]["x"][_pos]}`
                for(var i in this.arr1){
                    body += `,${this.arr1[i]["y"][_pos]}`
                }
                body += "\n"
            }

            //Export CSV
            let csv_data = header + body
            var fileName = "export.csv";//匯出的檔名
            var blob = new Blob(["\ufeff",csv_data], {
                type : "application/octet-stream"
            })
            var href = URL.createObjectURL(blob)
            var link = document.createElement("a")
            document.body.appendChild(link)
            link.href = href
            link.download = fileName
            link.click()
        }
    },
    mounted(){
        if(this.$props.datatype == 'PR' || this.$props.datatype == 'DMY' || this.$props.datatype == 'kwh' ||
        this.$props.datatype == 'RA'){
            this.datatype_interval = 1
            this.date_range = 1
            this.plot_type = "bar"
        }
        else{
            this.datatype_interval = 0
            if(this.$props.datatype == 'value'){
                this.equip_type = this.$props.type
            }
        }
        this.history_data_list()

        window.addEventListener("resize", this.plot_resize)
    },
    destroyed(){
        window.removeEventListener("resize", this.plot_resize)
    },
    watch:{
        date_range: function(){
            this.history_data_list()
        },
    }
}
</script>
